/* Forgotten Tribes — Story product section behaviour. Scoped per .ft-story root. */
(function(){
  function initStory(root){

  /* ---------- scroll reveals ---------- */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.15, rootMargin:'0px 0px -8% 0px'});
  root.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  /* anything inside a collapsed <details> never meets the observer, so reveal it on open.
     Also start/stop any video in there: a collapsed panel can't autoplay by itself, and a
     closed one should never keep playing. */
  root.querySelectorAll('details.ft-acc').forEach(function(d){
    d.addEventListener('toggle', function(){
      var vid = d.querySelector('video');
      if(d.open){
        d.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
        if(vid && vid.hasAttribute('autoplay')){
          vid.muted = true;                 /* browsers only autoplay muted video */
          var pr = vid.play();
          if(pr && pr.catch) pr.catch(function(){});
        }
      } else if(vid && !vid.paused){
        vid.pause();
      }
    });
  });

  /* ---------- pinned cloth scroller (only in the 'pinned' layout) ---------- */
  root.querySelectorAll('[data-ft-steps]').forEach(function(group){
    var img = group.closest('.ft-mat').querySelector('.sticky img');
    var steps = group.querySelectorAll('.ft-step');
    if(!img || !steps.length) return;
    var so = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        steps.forEach(function(s){ s.classList.remove('active'); });
        e.target.classList.add('active');
        var src = e.target.getAttribute('data-img');
        if(src && img.getAttribute('src') !== src){
          img.style.opacity = .5;
          setTimeout(function(){ img.src = src; img.style.opacity = 1; }, 160);
        }
      });
    },{threshold:.55});
    steps.forEach(function(s){ so.observe(s); });
    steps[0].classList.add('active');
  });

  /* ---------- big play button over an uploaded video ----------
     The browser's own control bar puts a small play button in the corner, which reads as
     chrome rather than an invitation. Strip the controls while it is idle, lay one large
     target over the poster, and hand the controls back the moment it starts. Autoplaying
     videos are left alone — they need no button — and so are YouTube/Vimeo embeds, whose
     playback we cannot drive from here. */
  root.querySelectorAll('.ft-videowrap video').forEach(function(v){
    var wrap = v.closest('.ft-videowrap');
    if(!wrap || v.hasAttribute('autoplay') || wrap.querySelector('[data-ft-videoplay]')) return;
    v.controls = false;
    v.removeAttribute('controls');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ft-videoplay';
    btn.setAttribute('data-ft-videoplay', '');
    btn.setAttribute('aria-label', 'Play video');
    btn.innerHTML = '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></span>';
    wrap.appendChild(btn);

    btn.addEventListener('click', function(){
      btn.hidden = true;
      v.controls = true;
      var pr = v.play();
      /* if the browser refuses, put the button back rather than leaving a dead poster */
      if(pr && pr.catch) pr.catch(function(){ btn.hidden = false; v.controls = false; });
    });
    /* back to the poster and the big button once it finishes */
    v.addEventListener('ended', function(){
      v.controls = false;
      btn.hidden = false;
      v.load();
    });
  });

  /* ---------- full-screen swipeable gallery ---------- */
  var openGallery = null;   /* set below once the full-screen gallery is wired up */
  var gal = root.querySelector('[data-ft-gal]');
  if(gal){
    var track   = gal.querySelector('[data-ft-gal-track]');
    var counter = gal.querySelector('[data-ft-gal-i]');
    var dots    = Array.prototype.slice.call(gal.querySelectorAll('[data-ft-gal-to]'));
    var slides  = Array.prototype.slice.call(gal.querySelectorAll('.ft-gal-slide'));
    var prevBtn = gal.querySelector('[data-ft-gal-prev]');
    var nextBtn = gal.querySelector('[data-ft-gal-next]');
    var lastFocus = null;
    var current = 0;

    if(slides.length < 2){
      if(prevBtn) prevBtn.hidden = true;
      if(nextBtn) nextBtn.hidden = true;
      gal.querySelector('[data-ft-gal-dots]').style.display = 'none';
    }

    /* load a slide's image and its neighbours only */
    function hydrate(i){
      [i-1, i, i+1].forEach(function(n){
        var s = slides[n];
        if(!s) return;
        var im = s.querySelector('img');
        if(im && !im.getAttribute('src')) im.setAttribute('src', im.getAttribute('data-src'));
      });
    }

    function mark(i){
      if(i === current) return;
      current = i;
      if(counter) counter.textContent = i + 1;
      dots.forEach(function(d, n){ d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      hydrate(i);
    }

    function goTo(i, smooth){
      i = Math.max(0, Math.min(slides.length - 1, i));
      hydrate(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      mark(i);
    }

    function open(i){
      lastFocus = document.activeElement;
      gal.classList.add('open');
      gal.setAttribute('aria-hidden','false');
      document.body.classList.add('ft-gal-lock');
      goTo(i, false);
      /* re-run once laid out, so clientWidth is definitely correct */
      requestAnimationFrame(function(){ goTo(i, false); track.focus({preventScroll:true}); });
    }

    function close(){
      gal.classList.remove('open');
      gal.setAttribute('aria-hidden','true');
      document.body.classList.remove('ft-gal-lock');
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openGallery = open;
    gal.querySelectorAll('[data-ft-gal-close]').forEach(function(b){ b.addEventListener('click', close); });
    dots.forEach(function(d){
      d.addEventListener('click', function(){ goTo(parseInt(d.getAttribute('data-ft-gal-to'), 10), true); });
    });
    if(prevBtn) prevBtn.addEventListener('click', function(){ goTo(current - 1, true); });
    if(nextBtn) nextBtn.addEventListener('click', function(){ goTo(current + 1, true); });

    /* keep counter/dots in sync with native swipe */
    var raf = null;
    track.addEventListener('scroll', function(){
      if(raf) return;
      raf = requestAnimationFrame(function(){
        raf = null;
        var w = track.clientWidth;
        if(w) mark(Math.round(track.scrollLeft / w));
      });
    }, {passive:true});

    document.addEventListener('keydown', function(e){
      if(!gal.classList.contains('open')) return;
      if(e.key === 'Escape'){ close(); }
      else if(e.key === 'ArrowRight'){ e.preventDefault(); goTo(current + 1, true); }
      else if(e.key === 'ArrowLeft'){ e.preventDefault(); goTo(current - 1, true); }
    });

    /* keep the current slide centred if the viewport rotates/resizes */
    window.addEventListener('resize', function(){
      if(gal.classList.contains('open')) goTo(current, false);
    });
  }

  /* ---------- swipeable hero ---------- */
  function pathOf(u){ try { return new URL(u, location.href).pathname; } catch(e){ return ''; } }

  var hTrack   = root.querySelector('[data-ft-herotrack]');
  var hSlides  = hTrack ? Array.prototype.slice.call(hTrack.querySelectorAll('.ft-heroslide')) : [];
  var hCurrent = 0;

  function hHydrate(i){
    [i-1, i, i+1].forEach(function(n){
      var sl = hSlides[n];
      if(!sl) return;
      var im = sl.querySelector('img');
      if(im && !im.getAttribute('src')){
        if(im.getAttribute('data-srcset')) im.setAttribute('srcset', im.getAttribute('data-srcset'));
        im.setAttribute('src', im.getAttribute('data-src'));
      }
    });
  }
  function hMark(i){
    if(i === hCurrent) return;
    hCurrent = i;
    hHydrate(i);
  }
  function hGoTo(i, smooth){
    if(!hTrack) return;
    i = Math.max(0, Math.min(hSlides.length - 1, i));
    hHydrate(i);
    hTrack.scrollTo({ left: i * hTrack.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    hMark(i);
  }
  /* move the hero to whichever photo belongs to the chosen variant */
  function heroToImage(src){
    if(!hSlides.length || !src) return;
    var want = pathOf(src);
    for(var i=0;i<hSlides.length;i++){
      var im = hSlides[i].querySelector('img');
      if(im && pathOf(im.getAttribute('data-src')) === want){ hGoTo(i, true); return; }
    }
  }

  if(hTrack){
    hHydrate(0);
    var hRaf = null;
    hTrack.addEventListener('scroll', function(){
      if(hRaf) return;
      hRaf = requestAnimationFrame(function(){
        hRaf = null;
        var w = hTrack.clientWidth;
        if(w) hMark(Math.round(hTrack.scrollLeft / w));
      });
    }, {passive:true});

    var pb = root.querySelector('[data-ft-heroprev]');
    var nb = root.querySelector('[data-ft-heronext]');
    if(pb) pb.addEventListener('click', function(e){ e.stopPropagation(); hGoTo(hCurrent - 1, true); });
    if(nb) nb.addEventListener('click', function(e){ e.stopPropagation(); hGoTo(hCurrent + 1, true); });

    /* tap opens full-screen, but a swipe must not count as a tap */
    var dsx = 0, dsy = 0, moved = false;
    hTrack.addEventListener('pointerdown', function(e){ dsx = e.clientX; dsy = e.clientY; moved = false; }, {passive:true});
    hTrack.addEventListener('pointermove', function(e){
      if(Math.abs(e.clientX - dsx) > 8 || Math.abs(e.clientY - dsy) > 8) moved = true;
    }, {passive:true});
    hTrack.addEventListener('click', function(){
      if(!moved && openGallery) openGallery(hCurrent);
    });
    hTrack.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ e.preventDefault(); hGoTo(hCurrent + 1, true); }
      else if(e.key === 'ArrowLeft'){ e.preventDefault(); hGoTo(hCurrent - 1, true); }
      else if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); if(openGallery) openGallery(hCurrent); }
    });
    window.addEventListener('resize', function(){ hGoTo(hCurrent, false); });
  }

  /* ---------- desktop photo carousel, built from the product's own media ----------
     Shopify only records one photo per colour (the variant image), and the alt text carries
     no colour. The media order does: merchants group the photos, so a colour's variant image
     marks where that colour's run starts, and the run ends where the next colour's begins.
     Anything before the first anchor belongs to no colour and shows for all of them.
     This replaces any hand-picked sets, so the carousel follows Shopify with nothing to
     maintain by hand. */
  function buildAutoTript(){
    var heroSec = root.querySelector('.ft-hero');
    if(!heroSec) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ft-heroslide img'));
    if(!slides.length) return;

    /* which option is the colour? read the label the merchant typed, not a fixed position */
    var colourPos = '';
    root.querySelectorAll('.ft-optgroup').forEach(function(g){
      var nm = g.querySelector('.ft-optname');
      var os = g.querySelector('.ft-opts');
      if(nm && os && /colou?r/i.test(nm.textContent || '')) colourPos = os.getAttribute('data-optpos');
    });

    /* colour -> the photo its variant image points at */
    var sel = root.querySelector('[data-ft-varselect]');
    var anchors = [], seenColour = {};
    if(sel && colourPos){
      for(var i=0;i<sel.options.length;i++){
        var o = sel.options[i];
        var c  = o.getAttribute('data-o' + colourPos);
        var im = o.getAttribute('data-img');
        if(!c || !im || seenColour[c]) continue;
        var want = pathOf(im), at = -1;
        for(var j=0;j<slides.length;j++){
          if(pathOf(slides[j].getAttribute('data-src')) === want){ at = j; break; }
        }
        if(at !== -1){ seenColour[c] = 1; anchors.push({colour:c, at:at}); }
      }
      anchors.sort(function(a,b){ return a.at - b.at; });
    }

    var setEl = document.createElement('div');
    setEl.className = 'ft-tript';
    setEl.setAttribute('data-ft-tript', '');
    setEl.setAttribute('data-ft-tript-auto', '');
    setEl.setAttribute('data-tript-colour', '');
    var trk = document.createElement('div');
    trk.className = 'ft-triptrack';
    trk.setAttribute('data-ft-triptrack', '');

    var cur = '';
    slides.forEach(function(sl, idx){
      for(var a=0;a<anchors.length;a++){ if(anchors[a].at === idx) cur = anchors[a].colour; }
      var full = sl.getAttribute('data-src') || sl.getAttribute('src') || '';
      var im = document.createElement('img');
      im.setAttribute('loading', 'lazy');
      im.setAttribute('decoding', 'async');
      im.setAttribute('sizes', '33vw');
      im.setAttribute('data-ft-triptimg', '');
      im.setAttribute('data-tript-panel-colour', cur);
      im.setAttribute('data-full', full);
      var ss = sl.getAttribute('data-srcset');
      if(ss) im.setAttribute('srcset', ss);
      im.src = full;
      im.alt = sl.getAttribute('alt') || '';
      trk.appendChild(im);
    });

    function navBtn(cls, attr, label, glyph){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ft-triptnav ' + cls;
      b.setAttribute(attr, '');
      b.setAttribute('aria-label', label);
      b.innerHTML = glyph;
      return b;
    }
    setEl.appendChild(trk);
    setEl.appendChild(navBtn('ft-triptprev', 'data-ft-triptprev', 'Previous photos', '&#8249;'));
    setEl.appendChild(navBtn('ft-triptnext', 'data-ft-triptnext', 'More photos', '&#8250;'));

    root.querySelectorAll('[data-ft-tript]').forEach(function(el){
      if(el.parentNode) el.parentNode.removeChild(el);
    });
    heroSec.appendChild(setEl);
    /* the set replaces the single big photo on desktop */
    heroSec.classList.add('has-tript');
  }
  buildAutoTript();

  /* ---------- desktop photo carousel ---------- */
  var triptSets   = Array.prototype.slice.call(root.querySelectorAll('[data-ft-tript]'));
  var triptSettle = [];

  triptSets.forEach(function(setEl){
    var trk  = setEl.querySelector('[data-ft-triptrack]');
    var prev = setEl.querySelector('[data-ft-triptprev]');
    var next = setEl.querySelector('[data-ft-triptnext]');
    if(!trk) return;

    /* one panel plus its gap — measured, so it stays right at any screen width */
    var stepPx = function(){
      var im = trk.querySelector('img');
      if(!im) return trk.clientWidth / 3;
      var cs = getComputedStyle(trk);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return im.getBoundingClientRect().width + gap;
    };
    var settle = function(){
      var scrollable = trk.scrollWidth > trk.clientWidth + 2;
      if(prev){ prev.hidden = !scrollable; prev.disabled = trk.scrollLeft <= 1; }
      if(next){ next.hidden = !scrollable;
        next.disabled = trk.scrollLeft >= trk.scrollWidth - trk.clientWidth - 1; }
    };
    var go = function(dir){
      var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      trk.scrollBy({ left: dir * stepPx(), behavior: smooth ? 'smooth' : 'auto' });
      setTimeout(settle, 420);
    };
    if(prev) prev.addEventListener('click', function(){ go(-1); });
    if(next) next.addEventListener('click', function(){ go(1); });
    trk.addEventListener('scroll', settle, {passive:true});
    window.addEventListener('resize', settle, {passive:true});
    window.addEventListener('load', settle);
    triptSettle.push(settle);
    settle();
  });

  /* show the photo set for the chosen colour, falling back to the "all colours" set */
  var applyTriptColour = function(){
    if(!triptSets.length) return;
    var picked = [];
    for(var k in chosen){
      if(chosen[k]) picked.push(String(chosen[k]).trim().toLowerCase());
    }
    var wanted = null;
    triptSets.forEach(function(el){
      var c = (el.getAttribute('data-tript-colour') || '').trim().toLowerCase();
      if(c && picked.indexOf(c) !== -1) wanted = el;
    });
    if(!wanted){
      triptSets.forEach(function(el){
        if(!wanted && !(el.getAttribute('data-tript-colour') || '').trim()) wanted = el;
      });
    }
    if(!wanted) wanted = triptSets[0];
    triptSets.forEach(function(el){ el.hidden = (el !== wanted); });
    /* the automatic set holds every colour at once: show only the chosen colour's run.
       If nothing matches (no colour option, or a colour with no photos of its own) the
       whole set stays visible rather than leaving an empty carousel. */
    if(wanted && wanted.hasAttribute('data-ft-tript-auto')){
      var trk = wanted.querySelector('[data-ft-triptrack]');
      if(trk){
        var panels = Array.prototype.slice.call(trk.querySelectorAll('img'));
        var matched = false;
        panels.forEach(function(im){
          var c = (im.getAttribute('data-tript-panel-colour') || '').trim().toLowerCase();
          if(c && picked.indexOf(c) !== -1) matched = true;
        });
        panels.forEach(function(im){
          var c = (im.getAttribute('data-tript-panel-colour') || '').trim().toLowerCase();
          im.style.display = (!matched || !c || picked.indexOf(c) !== -1) ? '' : 'none';
        });
        trk.scrollLeft = 0;
      }
    }
    /* a hidden track measures zero, so re-check the arrows once it is on screen */
    triptSettle.forEach(function(f){ f(); });
  };

  /* ---------- a panel opens the full-screen gallery ---------- */
  root.querySelectorAll('[data-ft-triptimg]').forEach(function(im){
    im.addEventListener('click', function(){
      if(!openGallery) return;
      /* open on the matching photo when the chosen image is one of the product's own */
      var want = pathOf(im.getAttribute('data-full'));
      var idx = 0;
      for(var i=0;i<hSlides.length;i++){
        var sl = hSlides[i].querySelector('img');
        if(sl && pathOf(sl.getAttribute('data-src')) === want){ idx = i; break; }
      }
      openGallery(idx);
    });
  });

  /* ---------- click-to-enlarge (size chart) ---------- */
  var lb = root.querySelector('[data-ft-lb]');
  if(lb){
    var lbImg = lb.querySelector('img');
    var lbLast = null;
    var lbClose = function(){
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden','true');
      document.body.classList.remove('ft-gal-lock');
      lbImg.removeAttribute('src');
      if(lbLast && lbLast.focus) lbLast.focus();
    };
    root.querySelectorAll('[data-ft-zoom]').forEach(function(z){
      z.addEventListener('click', function(){
        lbLast = z;
        lbImg.src = z.currentSrc || z.src;
        lbImg.alt = z.alt || '';
        lb.classList.add('open');
        lb.setAttribute('aria-hidden','false');
        document.body.classList.add('ft-gal-lock');
      });
    });
    lb.querySelector('[data-ft-lb-x]').addEventListener('click', lbClose);
    lb.addEventListener('click', function(e){ if(e.target === lb) lbClose(); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && lb.classList.contains('open')) lbClose();
    });
  }

  /* ---------- rating links jump to the review widget (hero + reviews chapter) ---------- */
  var revJumps = root.querySelectorAll('[data-ft-revjump]');
  if(revJumps.length){
    var REV_SEL = '.jdgm-review-widget, .spr-reviews, #shopify-product-reviews, .stamped-reviews-widget';
    /* resolve the widget when the link is clicked, not now: review apps inject
       their widget after this script has already run */
    revJumps.forEach(function(el){
      el.addEventListener('click', function(){
        var t = document.querySelector(REV_SEL);
        if(!t) return;
        var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
        t.scrollIntoView({behavior: smooth ? 'smooth' : 'auto', block:'start'});
      });
    });
    /* only fall back to plain text once the page has settled and there is still nothing */
    var revSettle = function(){
      var has = !!document.querySelector(REV_SEL);
      revJumps.forEach(function(el){
        el.classList.toggle('is-plain', !has);
        el.disabled = !has;
      });
    };
    window.addEventListener('load', revSettle);
    setTimeout(revSettle, 2500);
  }

  /* ---------- shop the look (complementary products) ---------- */
  var lookEl = root.querySelector('[data-ft-look]');
  if(lookEl){
    var lookGrid = lookEl.querySelector('[data-ft-lookgrid]');
    var lookCur = lookEl.getAttribute('data-ft-look-currency') || 'GBP';

    function lookMoney(cents){
      if(cents == null) return '';
      var v = cents / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: lookCur,
          minimumFractionDigits: v % 1 === 0 ? 0 : 2
        }).format(v);
      } catch(e){ return v.toFixed(2); }
    }

    fetch('/recommendations/products.json?product_id=' + lookEl.getAttribute('data-ft-look-pid') +
          '&intent=complementary&limit=8')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        var items = (data && data.products) || [];
        if(!items.length) return;                 /* nothing to show: stay hidden */
        items.forEach(function(prod){
          var a = document.createElement('a');
          a.className = 'ft-lookcard reveal in';  /* already on screen logic-wise, so reveal now */
          a.href = prod.url;

          var media = document.createElement('div');
          media.className = 'ft-lookmedia';
          if(prod.featured_image){
            var im = document.createElement('img');
            im.src = prod.featured_image;
            im.alt = prod.title || '';
            im.loading = 'lazy';
            media.appendChild(im);
          }
          a.appendChild(media);

          var name = document.createElement('div');
          name.className = 'ft-lookname';
          name.textContent = prod.title;
          a.appendChild(name);

          var price = document.createElement('div');
          if(prod.available === false){
            price.className = 'ft-looksold';
            price.textContent = 'Sold out';
          } else {
            price.className = 'ft-lookprice';
            if(prod.compare_at_price && prod.compare_at_price > prod.price){
              var was = document.createElement('span');
              was.className = 'ft-was';
              was.textContent = lookMoney(prod.compare_at_price);
              price.appendChild(was);
            }
            price.appendChild(document.createTextNode(lookMoney(prod.price)));
          }
          a.appendChild(price);
          lookGrid.appendChild(a);
        });
        lookEl.removeAttribute('hidden');
      })
      .catch(function(){ /* leave the section hidden */ });
  }

  /* ---------- floating back-to-top button ---------- */
  var sticky     = root.querySelector('[data-ft-sticky]');
  var buySection = root.querySelector('[data-ft-buysection]');
  if(sticky && buySection){
    var atPct = parseFloat(sticky.getAttribute('data-ft-sticky-at')) || 50;
    var buyVisible = false;

    /* Work out the trigger point up front rather than on every scroll frame: reading
       scrollHeight mid-scroll forces a reflow, and the page height only really changes
       when the window resizes or lazy images land. */
    var triggerPx = Infinity;
    var measureSticky = function(){
      var range = document.documentElement.scrollHeight - window.innerHeight;
      triggerPx = range > 0 ? range * (atPct / 100) : Infinity;
    };

    var paintSticky = function(){
      var show = window.scrollY >= triggerPx && !buyVisible;
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    /* hide it again once the Buy chapter is on screen — it would only cover what it points at */
    new IntersectionObserver(function(es){
      buyVisible = es[0].isIntersecting;
      paintSticky();
    },{threshold:0}).observe(buySection);

    var remeasure = function(){ measureSticky(); paintSticky(); };
    window.addEventListener('scroll', paintSticky, {passive:true});
    window.addEventListener('resize', remeasure, {passive:true});
    window.addEventListener('load', remeasure);
    /* lazy images and app widgets keep changing the page height after load, so take a
       couple of later readings rather than watching the body for every resize */
    setTimeout(remeasure, 1500);
    setTimeout(remeasure, 4000);
    remeasure();

    sticky.querySelector('[data-ft-sticky-btn]').addEventListener('click', function(){
      var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      buySection.scrollIntoView({behavior: smooth ? 'smooth' : 'auto', block:'start'});
    });
  }

  /* ---------- variant selection ---------- */
  var select  = root.querySelector('[data-ft-varselect]');
  var priceEl = root.querySelector('[data-ft-price]');
  var atc     = root.querySelector('[data-ft-atc]');
  var chosen  = {};
  var addLabel = (atc && atc.getAttribute('data-add-label')) || 'Add to bag';

  root.querySelectorAll('.ft-opts').forEach(function(group){
    var pos = group.getAttribute('data-optpos');
    var pressed = group.querySelector('.ft-opt[aria-pressed="true"]');
    if(pressed) chosen[pos] = pressed.getAttribute('data-value');
    group.querySelectorAll('.ft-opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        group.querySelectorAll('.ft-opt').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
        btn.setAttribute('aria-pressed','true');
        chosen[pos] = btn.getAttribute('data-value');
        sync();
      });
    });
  });

  var saleBadge = root.querySelector('[data-ft-salebadge]');
  var whyLink   = root.querySelector('[data-ft-whylink]');

  /* price for the chosen variant: was-price struck through, the live price in the sale colour,
     and the percentage worked out from the raw amounts (the money strings carry currency
     symbols and separators, so they are for display only). The badge and the "see why" link
     follow the same on-sale test, because a variant can be reduced while its neighbour is not. */
  function setPrice(match){
    if(!priceEl || !match) return;
    var price   = match.getAttribute('data-price');
    var compare = match.getAttribute('data-compare');
    var pCents  = parseInt(match.getAttribute('data-price-cents'), 10);
    var cCents  = parseInt(match.getAttribute('data-compare-cents'), 10);
    var onsale  = !!compare && !isNaN(pCents) && !isNaN(cCents) && cCents > pCents;

    priceEl.innerHTML = '';
    if(onsale){
      var was = document.createElement('span');
      was.className = 'ft-was';
      was.textContent = compare;
      priceEl.appendChild(was);
    }
    var now = document.createElement('span');
    now.className = 'ft-now' + (onsale ? ' is-sale' : '');
    now.textContent = price || '';
    priceEl.appendChild(now);

    if(onsale && priceEl.getAttribute('data-ft-showpct') === '1'){
      var off = document.createElement('span');
      off.className = 'ft-save';
      off.textContent = '-' + Math.round((cCents - pCents) * 100 / cCents) + '%';
      priceEl.appendChild(off);
    }
    if(saleBadge) saleBadge.hidden = !onsale;
    if(whyLink)   whyLink.hidden   = !onsale;
  }

  /* ---------- "see why" pop-up ---------- */
  var whyEl = root.querySelector('[data-ft-why]');
  if(whyEl && whyLink){
    var whyLast = null;
    var whyClose = function(){
      whyEl.classList.remove('open');
      whyEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ft-gal-lock');
      if(whyLast && whyLast.focus) whyLast.focus();
    };
    whyLink.addEventListener('click', function(){
      whyLast = document.activeElement;
      whyEl.classList.add('open');
      whyEl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ft-gal-lock');
      var x = whyEl.querySelector('[data-ft-why-close]');
      if(x) x.focus();
    });
    whyEl.querySelectorAll('[data-ft-why-close]').forEach(function(b){
      b.addEventListener('click', whyClose);
    });
    /* the backdrop closes it, the panel does not */
    whyEl.addEventListener('click', function(e){ if(e.target === whyEl) whyClose(); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && whyEl.classList.contains('open')) whyClose();
    });
  }

  function sync(){
    if(!select) return;
    var opts = select.options, match = null;
    for(var i=0;i<opts.length;i++){
      var o = opts[i];
      var ok = (!chosen['1'] || o.getAttribute('data-o1') === chosen['1'])
            && (!chosen['2'] || o.getAttribute('data-o2') === chosen['2'])
            && (!chosen['3'] || o.getAttribute('data-o3') === chosen['3']);
      if(ok){ match = o; break; }
    }
    if(!match) return;
    select.value = match.value;
    var soldout = match.disabled;
    if(atc){ atc.disabled = soldout; atc.textContent = soldout ? 'Sold out' : addLabel; }
    var img = match.getAttribute('data-img');
    if(img) heroToImage(img);
    applyTriptColour();
    setPrice(match);
  }

  /* pick the right photo set for whichever colour is selected on load */
  applyTriptColour();
  }

  /* one page can hold more than one Story section, and the theme editor swaps a section's
     markup without reloading the page — so boot every root once, and again on section load. */
  function bootStory(){
    document.querySelectorAll('.ft-story').forEach(function(r){
      if(r.dataset.ftStoryReady) return;
      r.dataset.ftStoryReady = '1';
      initStory(r);
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootStory);
  } else {
    bootStory();
  }
  document.addEventListener('shopify:section:load', bootStory);
})();
